module.exports = __webpack_public_path__ + "img/new.16501645.svg";